"use strict";

angular.module("licensure.services").factory("DataElements", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/dataelements/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                    });

                return d.promise;
            },

            getGenders: function (args) {
                var d = $q.defer();
                args.data_section_name = "gender";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getRaces: function (args) {
                var d = $q.defer();
                args.data_section_name = "race";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getHairColors: function (args) {
                var d = $q.defer();
                args.data_section_name = "hair";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getEyeColors: function (args) {
                var d = $q.defer();
                args.data_section_name = "eye color";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getHeights: function (args) {
                var d = $q.defer();
                args.data_section_name = "height";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getEducationOptions: function (args) {
                var d = $q.defer();
                args.data_section_name = "Highest Level of Education";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getStudyOptions: function (args) {
                var d = $q.defer();
                args.data_section_name =
                    "EMS Personnel's Degree Subject/Field of Study";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getTopicOptions: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EducationModule/Topics", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data.records);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getForeignLanguages: function (args) {
                var d = $q.defer();
                args.data_section_name = "Foreign Language Ability";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getVehicleLicenseTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Vehicle License Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getVehicleSpecialties: function (args) {
                var d = $q.defer();
                args.data_section_name = "Vehicle Specialty";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getVehicleTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Vehicle Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getEngineTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Engine Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getVehiclePermitStatuses: function (args) {
                var d = $q.defer();
                args.data_section_name = "Vehicle Permit Status";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getOrganizationTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Organization Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getOrganizationStatuses: function (args) {
                var d = $q.defer();
                args.data_section_name = "Organization Status";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getOrganizationalTaxStatuses: function (args) {
                var d = $q.defer();
                args.data_section_name = "Organizational Tax Status";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getOwnershipTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Ownership Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getMutualAidRelationships: function (args) {
                var d = $q.defer();
                args.data_section_name = "Mutual Aid Agreement Relationship";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getDaylightSavingsTimeUse: function (args) {
                var d = $q.defer();
                args.data_section_name = "Daylight Savings Time Use";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getTimeZones: function (args) {
                var d = $q.defer();
                args.data_section_name = "Time Zone";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },
            getServiceAreaTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Service Area Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getTrainingLevels: function (args) {
                var d = $q.defer();
                args.data_section_name = "Training Level";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getComplaintSources: function (args) {
                var d = $q.defer();
                args.data_section_name = "Complaint Source";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getDispositions: function (args) {
                var d = $q.defer();
                args.data_section_name = "Disposition";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getCategories: function (args) {
                var d = $q.defer();
                args.data_section_name = "Category";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getCompliances: function (args) {
                var d = $q.defer();
                args.data_section_name = "Compliance";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getVehicleMakes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Vehicle Make";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getMutualAidResponseTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Mutual Aid Response Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getResourceCategoryTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Resource Category Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getFireApparatusTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Fire Apparatus Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getFireApparatusPrimaryUses: function (args) {
                var d = $q.defer();
                args.data_section_name = "Fire Apparatus Primary Use";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getEMSPersonnelsPrimaryEMSJobRole: function (args) {
                var d = $q.defer();
                args.data_section_name = "EMS Personnel's Primary EMS Job Role";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getEMSPersonnelsOtherJobResponsibilities: function (args) {
                var d = $q.defer();
                args.data_section_name =
                    "EMS Personnel's Other Job Responsibilities";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getEmploymentTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Employment Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getEmploymentStatuses: function (args) {
                var d = $q.defer();
                args.data_section_name = "Personnel's Employment Status";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getACLSSponsor: function (args) {
                var d = $q.defer();
                args.data_section_name = "Sponsor - ACLS";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getCPRSponsor: function (args) {
                var d = $q.defer();
                args.data_section_name = "Sponsor - CPR";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getStructureTypes: function (args) {
                var d = $q.defer();
                args.data_section_name = "Structure Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getPALSSponsor: function (args) {
                var d = $q.defer();
                args.data_section_name = "Sponsor - PALS";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getServicePermitLevels: function (args) {
                var d = $q.defer();
                args.data_section_name = "Service Permit Level";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getOtherTypeOfService: function (args) {
                var d = $q.defer();
                args.data_section_name = "Other Type of Service";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getPrimaryTypeOfService: function (args) {
                var d = $q.defer();
                args.data_section_name = "Primary Type of Service";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getLengthOfService: function (args) {
                var d = $q.defer();
                args.data_section_name = "Length of Service";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getEmergencyPreparednessTrainingCourses: function (args) {
                var d = $q.defer();
                args.data_section_name =
                    "Emergency Preparedness Training Courses";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getWorkInOtherFields: function (args) {
                var d = $q.defer();
                args.data_section_name = "Work in Other Fields";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getWorkRelatedInjuryLength: function (args) {
                var d = $q.defer();
                args.data_section_name = "Work Related Injury Length";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getReasonsForPracticingOptions: function (args) {
                var d = $q.defer();

                d.resolve([
                    { id: "Very Satisfied", name: "Very Satisfied" },
                    { id: "Somewhat Satisfied", name: "Somewhat Satisfied" },
                    { id: "Neutral", name: "Neutral" },
                    {
                        id: "Somewhat Unsatisfied",
                        name: "Somewhat Unsatisfied"
                    },
                    { id: "Very Unsatisfied", name: "Very Unsatisfied" }
                ]);

                return d.promise;
            },

            getNumberOfEMSJobs: function (args) {
                var d = $q.defer();
                args.data_section_name = "Number of EMS Jobs";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getServiceLocationType: function (args) {
                var d = $q.defer();
                args.data_section_name = "Service Location Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getShiftLength: function (args) {
                var d = $q.defer();
                args.data_section_name = "Shift Length";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getVolunteerCompensation: function (args) {
                var d = $q.defer();
                args.data_section_name = "Volunteer Compensation";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getVolunteerLocation: function (args) {
                var d = $q.defer();
                args.data_section_name = "Volunteer Location";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getOutOfState: function (args) {
                var d = $q.defer();
                args.data_section_name = "Out Of State";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getNationallyRegistered: function (args) {
                var d = $q.defer();
                args.data_section_name = "Nationally Registered";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getTrainingBasis: function (args) {
                var d = $q.defer();
                args.data_section_name = "Training Basis";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getLicenseBasis: function (args) {
                var d = $q.defer();
                args.data_section_name = "License Basis";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getCourseLevel: function (args) {
                var d = $q.defer();
                args.data_section_name = "Course Level";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getTrainingType: function (args) {
                var d = $q.defer();
                args.data_section_name = "Training Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getServiceLicenseType: function (args) {
                var d = $q.defer();
                args.data_section_name = "Service License Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getProfessionalLicenseType: function (args) {
                var d = $q.defer();
                args.data_section_name = "Professional License Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getTrainingRegionApproving: function (args) {
                var d = $q.defer();
                args.data_section_name = "Training Region Approving";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getExamVerificationStatus: function (args) {
                var d = $q.defer();
                args.data_section_name = "Exam Verification Status";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getUserClassifications: function (args) {
                var d = $q.defer();
                args.data_section_name = "User Classification";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getPersonnelsEmploymentStatus: function (args) {
                var d = $q.defer();
                args.data_section_name = "Personnel's Employment Status";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getChargesPending: function (args) {
                var d = $q.defer();
                args.data_section_name = "Charges Pending";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getCriminalOffense: function (args) {
                var d = $q.defer();
                args.data_section_name = "Criminal Offense";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getIllegalDrugs: function (args) {
                var d = $q.defer();
                args.data_section_name = "Illegal Drugs";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getActionTaken: function (args) {
                var d = $q.defer();
                args.data_section_name = "Action Taken";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getCellProviders: function (args) {
                var d = $q.defer();
                args.data_section_name = "Cell Provider";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            },

            getCriminalHistoryStatus: function (args) {
                var d = $q.defer();
                args.data_section_name = "";
                var statuses = [
                    { id: "Pending", name: "Pending" },
                    { id: "Conviction", name: "Conviction" },
                    { id: "Absolved", name: "Absolved" }
                ];

                $http
                    .get(apiLocation + "/api/criminalhistory/getuserstatuses", {
                        params: {}
                    })
                    .then(function (response) {
                        if (response.data != null && response.data.length > 0) {
                            var combined = [];
                            for (var i = 0; i < statuses.length; i++) {
                                var shared = false;
                                for (var j = 0; j < response.data.length; j++) {
                                    if (response.data[j].name == statuses[i].name) {
                                        shared = true;
                                        break;
                                    }
                                }
                                if (!shared) combined.push(statuses[i]);
                            }
                            statuses = combined.concat(response.data);
                            d.resolve(statuses);
                        } else {
                            d.resolve(statuses);
                        }
                    })
                    .catch(function (response) {
                        d.resolve(statuses);
                    });

                return d.promise;
            },

            getConvictionType: function (args) {
                var d = $q.defer();
                var argsCopy = angular.copy(args);
                argsCopy.data_section_name = "Conviction Type";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: argsCopy
                    })
                    .then(function (response) {
                        argsCopy = null;
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        argsCopy = null;
                        console.log(response.data);
                    });

                return d.promise;
            },

            getLevelOfConviction: function (args) {
                var d = $q.defer();
                var argsCopy = angular.copy(args);
                argsCopy.data_section_name = "Level of Conviction";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: argsCopy
                    })
                    .then(function (response) {
                        argsCopy = null;
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        argsCopy = null;
                        console.log(response.data);
                    });

                return d.promise;
            },

            getCategoryOfOffenceCharge: function (args) {
                var d = $q.defer();
                var argsCopy = angular.copy(args);
                argsCopy.data_section_name = "Category of Offense/Charge";

                $http
                    .get(apiLocation + "/api/dataelements", {
                        params: argsCopy
                    })
                    .then(function (response) {
                        argsCopy = null;
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        argsCopy = null;
                        console.log(response.data);
                    });

                return d.promise;
            },

            getServiceType: function (args) {
                var d = $q.defer();
                var argsCopy = angular.copy(args);
                argsCopy.data_section_name = "Service Type";
                $http
                    .get(apiLocation + '/api/dataelements', {
                        params: argsCopy
                    })
                    .then(function (response) {
                        argsCopy = null;
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        argsCopy = null;
                        console.log(response.data);
                    });
                return d.promise;
            },

            getVoucherAmounts: function (args) {
                var d = $q.defer();
                var argsCopy = angular.copy(args);
                argsCopy.data_section_name = "Voucher Amounts";
                $http
                    .get(apiLocation + '/api/dataelements', {
                        params: argsCopy
                    })
                    .then(function (response) {
                        argsCopy = null;
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        argsCopy = null;
                        console.log(response.data);
                    });
                return d.promise;
            },

            getServiceClassification: function (args) {
                var d = $q.defer();
                var argsCopy = angular.copy(args);
                argsCopy.data_section_name = "Service Classification";
                $http
                    .get(apiLocation + '/api/dataelements', {
                        params: argsCopy
                    })
                    .then(function (response) {
                        argsCopy = null;
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        argsCopy = null;
                        console.log(response.data);
                    });
                return d.promise;
            },

            getEmergencyMedicalDispatches: function (args) {
                var d = $q.defer();
                var argsCopy = angular.copy(args);
                argsCopy.data_section_name = "Emergency Medical Dispatch";
                $http
                    .get(apiLocation + '/api/dataelements', {
                        params: argsCopy
                    })
                    .then(function (response) {
                        argsCopy = null;
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        argsCopy = null;
                        console.log(response.data);
                    });
                return d.promise;
            }
        };
    }
]);
